import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Location } from '@angular/common';

import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Directive({
    selector: '[finderClickScrollTo]',
    standalone: true
})
export class ClickScrollToDirective {
    @Input() scrollId: string;
    @Input() offsetElement: string;

    constructor(
        private window: WindowRef,
        private location: Location,
        private elementRef: ElementRef,
    ) { }

    @HostListener('click', ['$event'])
    onClick(event) {
        const window = this.getWindowRef();
        const document = window.document;

        // The scrollId can be something like `/path/to/url#scroll-to`
        // We need to chop it at the '#' to get the ID
        this.scrollId = this.scrollId.split('#').at(-1);

        const target = document.getElementById(this.scrollId);
        if (!target) {
            return;
        }

        event.preventDefault();

        // Check if we are have an offset element
        let scrollOffset = 0;
        const el = this.elementRef.nativeElement;
        const offsetEl = el.closest(this.offsetElement);
        if (offsetEl) {
            const navRect = offsetEl.getBoundingClientRect();

            // Check if target has padding/margin top
            // The computed style will always return a value (default 0px)
            let padding = 0;
            const targetStyles = window.getComputedStyle(target);
            const targetPadTop = Number(targetStyles.getPropertyValue('padding-top').match(/(\d+)/)[0]);
            if (targetPadTop === 0) {
                padding = 10;
            }

            // Set offset
            scrollOffset = navRect.height + padding;
        }

        if (scrollOffset === 0) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        } else {
            const rect = target.getBoundingClientRect();
            const elTop = window.scrollY - document.documentElement.clientTop + rect.top;
            window.scrollTo({
                top: Math.round(elTop - scrollOffset),
                behavior: 'smooth'
            });
        }

        // Set hash
        this.location.replaceState(`${this.location.path()}/#${this.scrollId}`);
    }

    /* istanbul ignore next */
    getWindowRef(): Window {
        return this.window.nativeWindow;
    }
}
